import { MooringCheckList } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const MOORING_ARRIVAL_CHECK_LIST_DATA_TAG = 'MooringArrivalCheckList';
const MOORING_DEPARTURE_CHECK_LIST_DATA_TAG = 'MooringDepartureCheckList';
class MooringCheckListParser extends OldRecordsParser {
    constructor(protocolTypeId, dataTag, app) {
        super(protocolTypeId, FIXED_PROTOCOL_CONTENT_TYPE_IDS.MOORING_CHECKLIST, dataTag, app);
    }
    getPropsMapping() {
        return {
            port: 'port',
            freeText: 'freeText',
        };
    }
    createData(props) {
        return new MooringCheckList(props.port, props.freeText);
    }
}
export class MooringArrivalCheckListParser extends MooringCheckListParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_ARRIVAL_CHECKLIST, MOORING_ARRIVAL_CHECK_LIST_DATA_TAG, app);
    }
}
export class MooringDepartureCheckListParser extends MooringCheckListParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_DEPARTURE_CHECKLIST, MOORING_DEPARTURE_CHECK_LIST_DATA_TAG, app);
    }
}
//# sourceMappingURL=MooringCheckListParser.js.map